export default {
      id: "common__pump_lg-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#common__pump_lg",
      toString: function () {
        return this.url;
      }
    }